import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductApi } from '../../api/product-api';
import { SyncDataJob } from '../../models/settings/sync-data-job';
import { FileSystemService } from '../../services/file-system.service';
import { Repository } from '../base/repository';

/**
 * Data-access layer for POS sync jobs.
 *
 * Deliberately uncached. A sync job is a status record whose whole value is being current - serving a cached one
 * would show a job as still running after it finished, or as finished after a new one started. The
 * `FileSystemService` dependency is only here because the base constructor requires it.
 */
@Injectable()
export class SyncRepository extends Repository {
  constructor(
    fileSystemService: FileSystemService,
    protected productAPI: ProductApi
  ) {
    super(fileSystemService);
  }

  public getSyncJobs$(jobIds: string[] = null, locationId: number = null): Observable<SyncDataJob[]> {
    return this.productAPI.getSyncJobs$(jobIds, locationId);
  }

  public createSyncJob$(job: SyncDataJob): Observable<SyncDataJob> {
    return this.productAPI.createSyncJob$(job);
  }
}
